export default {
	balance: 0,
	pin: null
}